import { ChangeDetectionStrategy, Component, forwardRef, output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaIconComponent, FormsModule],
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlideToggleFormControlComponent),
        },
    ],
    selector: 'app-slide-toggle-form-control',
    styleUrl: './slide-toggle-form-control.component.scss',
    templateUrl: './slide-toggle-form-control.component.html',
})
export class SlideToggleFormControlComponent implements ControlValueAccessor {
    public change = output<boolean>();
    public disabled = false;
    public value = false;

    public registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: never): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public writeValue(value: boolean): void {
        this.value = value;
    }

    protected onChange = (value: boolean): void => {
        this.change.emit(value);
    };

    protected onTouched = (): void => {};
}
